enum Language {
  DEFAULT = 'pt-BR',
  PTBR = 'pt-BR',
  EN = 'en-US',
  ES = 'es',
}

export { Language };
